import { showToastMessage } from "../../../../../../stateManagement/reducers"
import { store } from "../../../../../../stateManagement/store"
import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions"

export function handleFeatureCameras(feature: any) {
    const [, id] = feature?.id.split('.')
    if (id && feature.properties.ImageType != 2) {
        navigateTo(`/app/cameras/${id}`)
    } else {
        store.dispatch(showToastMessage({ messageText: 'Данные с камеры отсутствуют', messageType: "error", windowType: "map" }))
    }
}